document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => {
        drawer.renderContents({ sections: res });
      });
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});
